import { combineReducers } from 'redux';
import entitiesReducer from './entities';
import apiReducer from './api';
import loginReducer from './login';

const rootReducer = combineReducers({
  entities: entitiesReducer,
  // app: appReducer,
  api: apiReducer,
  login: loginReducer
});

// GLOBAL ACTIONS
export default (state, action) => {
  if (action.type === 'RESET_APP') {
    state = undefined;
  }
  return rootReducer(state, action);
};
